var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "slider-container",
      staticClass: "hero-unit-slider",
      style: { paddingBottom: _vm.paddingBottom },
    },
    [
      _c(
        "div",
        { staticClass: "slider-wrapper hero-unit-slider__swiper" },
        [
          _c(
            "swiper",
            { ref: "slider", attrs: { options: _vm.swiperOptions } },
            _vm._l(_vm.sliderData, function (slide, index) {
              return _c("swiper-slide", { key: index }, [
                _c("div", { staticClass: "hero-unit-slider__slide" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy:background-image",
                        value: slide.image_url,
                        expression: "slide.image_url",
                        arg: "background-image",
                      },
                    ],
                    key: slide.image_url,
                    staticClass: "image",
                  }),
                ]),
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "container pagination-container" }, [
            _c("div", {
              staticClass: "swiper-pagination",
              attrs: { slot: "pagination" },
              slot: "pagination",
            }),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/HeroSlider.vue